import app from '../../public-api';
import { mountVueComponent } from '../../../../shared/components/vue-factory';
import { translate } from '../../../../shared/services/I18nService';
import SettingsPanel from './settings-panel';
import VueVisibilityPanel from './VisibilityPanel';
import { makeDiv } from '../viewport-overlay';

const loader = {
  name: 'us:settings:visibility-panel',

  extends: 'uScope',

  dependencies: ['us:user-config'],

  factory (uScope, userConfig) {
    const settingsPanel = new SettingsPanel(uScope, userConfig);
    const visibilityPanel = makeVisibilityPanel(settingsPanel);
    makeToolbarButton(visibilityPanel);

    return visibilityPanel;

    function makeVisibilityPanel (settingsPanel) {
      const { div, id } = makeDiv();
      uScope.getContainer().appendChild(div);

      const comp = mountVueComponent({ el: `#${id}` }, VueVisibilityPanel, { userConfig, settingsPanel });
      return comp.$children[0]; // consider mount returns this <--
    }

    function makeToolbarButton (visibilityPanel) {
      const dialog = visibilityPanel;
      const { div } = makeDiv();
      div.classList.add('lbs-uscope-toolbar-button', 'us-settings-icon');
      div.addEventListener('click', dialog.toggleVisibility);
      div.title = translate('uScope.others.toolbar.settings-panel'); // moved after translating

      uScope.topToolbar.addButton(div, Number.MAX_SAFE_INTEGER);
    }
  }
};

app.plugins.register(loader);
